import type { ReactNode } from 'react';
import type { CasinoGroup } from 'utils/casino';

export enum ItemType {
  all = 'all',
  category = 'category',
  lobby = 'lobby',
  favorites = 'favorites',
  live = 'live',
}

export type ActiveItem =
  | { type: ItemType.category; id: string }
  | { type: Exclude<ItemType, ItemType.category> };

export type Item = {
  type: ItemType;
  id: string;
  name?: string;
  active: boolean;
  icon?: ReactNode;
};

export type CasinoCategoriesProps = {
  activeItems?: ActiveItem[];
  group: CasinoGroup;
};
